(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["padel_sticky_header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const header = document.getElementById('BoxStickyHeader-{{ section.id }}');
    if (!header) return;

    const button = header.querySelector('.box-sticky-header__menu-button');
    const menu = header.querySelector('.box-sticky-header__mobile-menu');

    if (button && menu) {
      button.addEventListener('click', () => {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isOpen));
        menu.hidden = isOpen;
      });

      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          button.setAttribute('aria-expanded', 'false');
          menu.hidden = true;
        });
      });
    }

    const setScrolled = () => {
      header.classList.toggle('box-sticky-header--scrolled', window.scrollY > 24);
    };

    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
